import { useEffect } from 'react';
import { Modal, Box, IconButton, CircularProgress, Typography } from '@mui/material';
import { Close } from '@mui/icons-material';

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '95%', md: '80%' },
    height: { xs: '80%', md: '90%' },
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 2,
    display: 'flex',
    flexDirection: 'column',
};

const scrollableContentStyle = {
    flexGrow: 1,
    height: '100%',
    overflowY: 'scroll', // This ensures a vertical scrollbar appears when content overflows
    p: 2,
    backgroundColor: '#f5f5f5',
    border: '1px solid #ccc',
};

export default function DocumentViewerModal({ open, onClose, content, contentType, fileName, loading }) {
    // Clean up temporary object URL for PDFs to prevent memory leaks
    useEffect(() => {
        return () => {
            if (contentType === 'pdf' && content) {
                URL.revokeObjectURL(content);
            }
        };
    }, [content, contentType]);

    const renderContent = () => {
        if (loading) {
            return <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}><CircularProgress /></Box>;
        }
        if (!content) {
            return <Typography>No document to display.</Typography>;
        }

        switch (contentType) {
            case 'pdf':
                return <iframe src={content} title={fileName} width="100%" height="100%" style={{ border: 'none' }} />;
            case 'text':
                return <Box sx={scrollableContentStyle}><pre style={{ margin: 0, whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{content}</pre></Box>;
            case 'html':
                return <Box sx={{...scrollableContentStyle, fontFamily: 'sans-serif' }} dangerouslySetInnerHTML={{ __html: content }} />;
            default:
                return <Typography>Unsupported file type.</Typography>;
        }
    };

    return (
        <Modal open={open} onClose={onClose}>
            <Box sx={modalStyle}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                    <Typography variant="h6">{fileName || 'Document Viewer'}</Typography>
                    <IconButton onClick={onClose}><Close /></IconButton>
                </Box>
                <Box sx={{ flexGrow: 1, border: '1px solid #ccc', overflow: 'hidden'  }}>
                    {renderContent()}
                </Box>
            </Box>
        </Modal>
    );
}
